import React from 'preact/compat';
import { h } from 'preact';

const Types = ["Other", "Item name", "Item description", "Item price", "Section name", "Section description"];

export function PdfMatch(props) {
  return <div className={"matches"}>
    <header className={"nav"}>
      <h2>Please tell us know what are the following:</h2>
      <nav>
        <button className={"btn primary"} onClick={props.analyze}>Next</button>
      </nav>
    </header>

    <ul>
      {props.matches.map(it => <li>
        <label>{it.text}</label>
        <select onChange={(ev) => props.onChange(it, ev.target.value)}>
          {Types.map(it => <option value={it}>{it}</option>)}
        </select>
      </li>)}
    </ul>
  </div>;
}
